import { render, staticRenderFns } from "./RequestServiceObject.vue?vue&type=template&id=6318c596&scoped=true"
import script from "./RequestServiceObject.vue?vue&type=script&lang=js"
export * from "./RequestServiceObject.vue?vue&type=script&lang=js"
import style0 from "./RequestServiceObject.vue?vue&type=style&index=0&id=6318c596&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6318c596",
  null
  
)

export default component.exports